<template>
  <form action="form-wrap">
    <!-- D: table write -->
    <div class="c-board-write">
      <div class="tr">
        <div class="th">
          <span class="c-required">
            <span class="sr-only">필수</span>
          </span>
          문의유형
        </div>
        <div class="td">
          <div class="c-round-button-box type-mo-scroll">
            <div
              class="c-radio-round type-black"
              v-for="category in categories"
              :key="category.id"
            >
              <input
                type="radio"
                :id="'inquiry-radio1-' + category.id"
                name="inquiry-radio1"
                :value="category.id"
                v-model="selectedCategory"
                @change="handleChange"
              />
              <label :for="'inquiry-radio1-' + category.id">{{
                category.label
              }}</label>
            </div>
          </div>
        </div>
      </div>
      <div v-if="selectedCategory && data.one.list.length > 0" class="tr">
        <div class="th">자주 찾는 질문</div>
        <div class="td">
          <div class="c-faq" data-accordion-wrap>
            <ul>
              <li v-for="(item, idx) in data.one.list" :key="idx">
                <!--
                  D: 아코디언
                  1. 클릭시(활성화) aria-expanded true 나머지 형제들 false
                  3. 클릭시 accordion-content에 aria-hiddne="false"로 값을 변경해주셔야 콘텐츠 나옵니다
                -->
                <button
                  type="button"
                  class="accordion-button"
                  data-accordion-trigger
                  :aria-expanded="data.one.expendIndex === idx"
                  :aria-controls="'act' + idx"
                  @click="btnCmd('expendClick', { index: idx })"
                >
                  <span class="question">
                    <span class="sr-only">질문</span>
                  </span>
                  <strong class="title">{{ item.faqTitleNm }}</strong>
                </button>
                <div
                  :id="'act' + idx"
                  class="accordion-content"
                  data-accordion-content
                  :aria-hidden="data.one.expendIndex !== idx"
                  v-html="item.faqCn"
                ></div>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 카테고리 : 주문 -->
      <div v-if="selectedCategory === 10" class="tr">
        <div class="th">문의주문</div>
        <div class="td">
          <div class="c-form-field">
            <label
              class="c-input-group type-choice"
              :class="{
                'is-choice': data.order.title,
              }"
            >
              <input
                type="text"
                disabled
                placeholder="주문 내역을 선택해 주세요"
                title="주문 내역을 선택해 주세요"
                v-model="data.order.title"
              />
              <button
                type="button"
                class="c-btn-icon btn-small-delete"
                @click="btnCmd('orderDelete', { index: -1 })"
              >
                <span class="c-icon icon-small-x"></span>
              </button>
            </label>
            <button
              type="button"
              class="c-button type-line-black type-small"
              @click="btnCmd('orderSelect')"
            >
              <span>주문 선택</span>
            </button>
          </div>

          <!-- D: 검색에서 선택한 제품 칩 -->
          <div class="c-search-chips">
            <div
              class="chip-item"
              v-for="(item, idx) in data.order.chkItem"
              :key="idx"
            >
              <p class="text">{{ item.zzmaktx }}</p>
              <button
                type="button"
                class="btn-delete"
                @click="btnCmd('orderDelete', { index: idx })"
              >
                <i class="c-icon icon-small-x"></i>
                <span class="sr-only">삭제</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 카테고리 : 주문 -->

      <!-- 카테고리 : 제품, 재고문의 -->
      <div v-if="selectedCategory === 20 || selectedCategory === 40" class="tr">
        <div class="th">문의제품</div>
        <div class="td">
          <!-- D: data-layer-hidden 속성 존재시 단순 검색 케이스로 바뀜 -->
          <SearchCustKeyword
            v-model:keyword="keyword"
            @keyword-changed="(prodItem) => settingProd('prod', prodItem)"
          />

          <!-- D: 검색에서 선택한 제품 칩 -->
          <div class="c-search-chips">
            <div
              class="chip-item"
              v-for="(item, idx) in data.keyword.prodList"
              :key="idx"
            >
              <p class="text">{{ item.keyword }}</p>
              <button
                type="button"
                class="btn-delete"
                @click="btnCmd('prodDelete', { index: idx })"
              >
                <i class="c-icon icon-small-x"></i>
                <span class="sr-only">삭제</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- 카테고리 : 제품, 재고문의 -->

      <!-- 카테고리 : 주문 -->
      <div class="tr last">
        <div class="th">
          <span class="c-required">
            <span class="sr-only">필수</span>
          </span>
          문의내용
        </div>
        <div class="td">
          <div class="c-textarea-area">
            <label for="user-message" class="sr-only"
              >취소신청사유 신청란</label
            >
            <textarea
              id="user-message"
              placeholder="문의내용을 입력해 주세요(3,000자 이내)"
              @click="btnCmd('textArea')"
              v-model="data.save.textArea"
            ></textarea>
          </div>
        </div>
      </div>
    </div>

    <div class="c-btn-area has-fixed-visible is-fixed" data-bottom-fixed>
      <button
        type="button"
        class="c-button type-secondary"
        style="--btn-width: 280px"
        @click="btnCmd('reset')"
        :disabled="data.btnFlag"
      >
        <span>초기화</span>
      </button>
      <button
        type="button"
        class="c-button type-primary"
        style="--btn-width: 280px"
        @click="btnCmd('save')"
        :disabled="data.btnFlag"
      >
        <span>문의하기</span>
      </button>
    </div>
  </form>

  <orderSelectedPop
    v-if="data.popup.isOrderSelectedPop"
    @choose="(orderItem) => settingProd('order', orderItem)"
    @close="closePopup"
  />
</template>
<script setup name="inquiryTab">
import { reactive, inject, ref, provide, onMounted } from "vue";
import orderSelectedPop from "@/components/paintpro/custCenter/orderSelectedPop.vue"; //주문선택 팝업
import SearchCustKeyword from "@/components/paintpro/custCenter/searchCustKeyword.vue";

import * as store from "@/store";
import * as cmApi from "@/api/cmApi";
import * as cmUtil from "@/utils/cmUtil.js";

import { api } from "@/plugins/api";
import { useRouter } from "vue-router";

const router = useRouter();
const url = inject("url_prefix");
const keyword = ref("");
// const { isMobile } = cmUtil.useDeviceType();

/***********************
 * 데이타 모음
 **********************/
const data = reactive({
  page: {
    userLoginInfo: {},
    empIndex: 0,
  },
  popup: {
    isOrderSelectedPop: false, //주문 선택 팝업
  },
  one: {
    expendIndex: -1,
    list: [],
  },
  order: {
    title: "",
    chkItem: [],
    isInputKey: true,
  },
  keyword: {
    prodList: [],
  },
  save: {
    textArea: "",
  },
  btnFlag: true,
});

/**********************
 * 마운트
 *********************/
onMounted(() => {
  pageInitData();
});

/**********************
 * 페이지 초기 데이타 조회
 *********************/
async function pageInitData() {
  // ◼◼◼ 초기데이타 조회
  const mparm = [];

  const res = await cmApi.getPageInitData(mparm);
  const { resultCode } = res;
  if (resultCode !== 200) {
    // alert(`errror : resultCode:${resultCode}, message:${message} `);
    return false;
  }

  const { userLoginInfo } = res.data;
  data.page.userLoginInfo = userLoginInfo;
  data.page.empIndex = store.useEventBusStore()?.salesPersonIndex;
}

/***********************
 * 카테고리 데이터
 **********************/
const selectedCategory = ref("");
const categories = [
  { id: 10, label: "주문", value: "order" },
  { id: 20, label: "제품", value: "product" },
  { id: 30, label: "사이트", value: "site" },
  { id: 40, label: "재고문의", value: "stock" },
  { id: 50, label: "기타", value: "etc" },
];

// 카테고리 변경에 따른 재 조회
const handleChange = () => {
  searchCmd("category", { index: selectedCategory.value });
};

/**********************
 * 팝업 모음
 *********************/
const closePopup = () => {
  data.popup.isOrderSelectedPop = false;
};

provide("closePopup", closePopup);

/**********************
 * 조회 모음
 *********************/
async function searchCmd(cmd = "", params = {}) {
  if (cmd == "category") {
    const res = await api.post(`${url}/custCenter/selectQna01`, {
      tabType: "qna",
      faqTypeCd: params.index,
    });
    data.one.expendIndex = -1;
    data.one.list = res.data.list;
    data.btnFlag = false;
  }
}

/**********************
 * 버튼 모음
 *********************/
async function btnCmd(cmd = "", params = {}) {
  // 아코디언 활성화
  if (cmd === "expendClick") {
    if (data.one.expendIndex == params.index) {
      data.one.expendIndex = -1;
    } else {
      data.one.expendIndex = params.index;
    }
  }
  //문의 유형 클릭 전 문의내용 선택 시
  else if (cmd === "textArea") {
    if (selectedCategory.value == null || selectedCategory.value == "") {
      await cmUtil.alert("문의유형을 선택해 주세요.");
      return;
    }
  }
  //주문 > 문의 주문 팝업
  else if (cmd == "orderSelect") {
    data.popup.isOrderSelectedPop = true;
    data.order.title = null;
    data.order.chkItem = [];
  }
  // 주문 > 주문 내역의 상품 삭제
  else if (cmd == "orderDelete") {
    if (params.index == -1) {
      data.order.title = null;
      data.order.chkItem = [];
      data.order.isInputKey = true;
    } else {
      data.order.chkItem.splice(params.index, 1);
      if (data.order.chkItem.length == 0) {
        data.order.title = null;
      }
    }
  }
  // 제품 > 등록한 제품 삭제
  else if (cmd == "prodDelete") {
    data.keyword.prodList.splice(params.index, 1);
  }
  // 초기화
  else if (cmd == "reset") {
    data.order.title = "";
    data.order.chkItem = [];
    data.keyword.prodList = [];
    data.save.textArea = null;
  }
  // 문의하기
  else if (cmd == "save") {
    if (data.save.textArea == null || data.save.textArea == "") {
      await cmUtil.alert("문의내용은 필수입력 입니다.");
      return;
    }
    let saveParam = {};
    let list = [];

    // 주문 카테고리
    if (selectedCategory.value === 10) {
      for (let i in data.order.chkItem) {
        list.push(data.order.chkItem[i].goodsSn);
      }
    }
    // 제품, 재고문의 카테고리
    else if (selectedCategory.value === 20 || selectedCategory.value === 40) {
      for (let i in data.keyword.prodList) {
        list.push(data.keyword.prodList[i].goods);
      }
    }

    saveParam.orderSn =
      selectedCategory.value === 10
        ? data.order.chkItem[0] != null
          ? data.order.chkItem[0].orderSn
          : 0
        : 0;
    saveParam.qstnTypeCd = selectedCategory.value;
    saveParam.zempNo =
      data.page.userLoginInfo.empList[data.page.empIndex].kunn2;
    saveParam.qstnCn = data.save.textArea.replaceAll("\n", "<br/>");
    saveParam.dtlList = list.length > 0 ? list : [];
    //이메일 템플릿 필수 내용
    saveParam.zbpName = data.page.userLoginInfo.zbpName;
    saveParam.zemail =
      data.page.userLoginInfo.empList[data.page.empIndex].zemail;

    if (selectedCategory.value === 10) {
      saveParam.emailQstnCn =
        "[주문] </br>" +
        data.order.title +
        "<br/>" +
        data.save.textArea.replaceAll("\n", "<br/>");
    } else if (selectedCategory.value === 20) {
      let pro = "";
      for (let i in data.keyword.prodList) {
        pro += data.keyword.prodList[i].keyword + "<br/>";
      }

      if (pro != null) {
        saveParam.emailQstnCn =
          "[제품] </br>" + pro + data.save.textArea.replaceAll("\n", "<br/>");
      } else {
        saveParam.emailQstnCn =
          "[제품] </br>" +
          "<br/>" +
          data.save.textArea.replaceAll("\n", "<br/>");
      }
    } else if (selectedCategory.value === 30) {
      saveParam.emailQstnCn =
        "[사이트] </br>" + data.save.textArea.replaceAll("\n", "<br/>");
    } else if (selectedCategory.value === 40) {
      let pro = "";
      for (let i in data.keyword.prodList) {
        pro += data.keyword.prodList[i].keyword + "<br/>";
      }

      if (pro != "") {
        saveParam.emailQstnCn =
          "[재고문의] </br>" +
          pro +
          data.save.textArea.replaceAll("\n", "<br/>");
      } else {
        saveParam.emailQstnCn =
          "[재고문의] </br>" +
          "<br/>" +
          data.save.textArea.replaceAll("\n", "<br/>");
      }
    } else {
      saveParam.emailQstnCn =
        "[기타] </br>" + data.save.textArea.replaceAll("\n", "<br/>");
    }

    const res = await api.post(`${url}/custCenter/insertInquirt`, saveParam);
    if (res.data > 0) {
      await cmUtil.alert("1:1문의가 정상적으로 등록 되었습니다.");

      routerCmd();
    }
  }
}

/**********************
 * 선택한 주문, 상품 세팅
 *********************/
async function settingProd(cmd = "", item) {
  // 주문 내역 선택 팝업 > 주문 내역의 제품 선택 후
  if (cmd == "order") {
    data.popup.isOrderSelectedPop = false;
    data.order.chkItem = [];

    /* 주문 건과 선택한 상품 분리 */
    // 주문 건 : SAP번호가 없는경우 페인트프로 ORDER_NO로 보여주기
    let orderNo = null;
    if (item[0].sapOrderNo == null) {
      orderNo = item[0].orderNo;
    } else {
      orderNo = item[0].sapOrderNo;
    }

    data.order.title =
      item[0].orderDt +
      "    (주문번호: " +
      orderNo +
      " ) " +
      (item[0].zzmaktx || "");
    item[0].orderCnt > 0
      ? " 외 " + item[0].orderCnt + "건"
      : "" + "          " + item[0].goodsUntprc + "원";

    // 상품
    for (let i = 1; i < item.length; i++) {
      data.order.chkItem.push(item[i]);
    }

    data.order.isInputKey = false;
  }
  //제품 및 재고문의
  else if (cmd == "prod") {
    const findGood = data.keyword.prodList.find(
      (param) => param.goods == item.goods
    );

    if (findGood != null && findGood != undefined) {
      await cmUtil.alert("이미 선택한 제품입니다.");
      keyword.value = "";
      return;
    } else {
      data.keyword.prodList.push(item);
    }
    keyword.value = "";
  }
}

/**********************
 * router
 *********************/
async function routerCmd() {
  router.push({
    name: "/paintpro/utility/inquireList",
  });
}
</script>
